var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createContext, useReducer, useContext, useMemo, } from "react";
var initialState = {
    message: "",
    type: "",
    returnMessage: "",
    returnRoute: "",
};
var StateContext = createContext(undefined);
var ActionsContext = createContext(undefined);
var playerErrorMessageReducer = function (state, action) {
    switch (action.type) {
        case "SHOW":
            return __assign(__assign({}, state), { message: action.message, type: action.messageType });
        case "HIDE":
            return __assign(__assign({}, state), { message: "", type: "" });
        case "RETURN_TO":
            return __assign(__assign({}, state), { returnRoute: action.route, returnMessage: action.returnMessage });
        default:
            return state;
    }
};
export var PlayerErrorMessageProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(playerErrorMessageReducer, initialState), state = _b[0], dispatch = _b[1];
    var timeoutRef = React.useRef(null);
    var actions = useMemo(function () { return ({
        show: function (message, type, duration) {
            if (duration === void 0) { duration = 1000; }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            dispatch({ type: "SHOW", message: message, messageType: type });
            if (duration) {
                timeoutRef.current = setTimeout(function () {
                    dispatch({ type: "HIDE" });
                }, duration);
            }
        },
        hide: function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            dispatch({ type: "HIDE" });
        },
        returnTo: function (route, returnMessage) {
            dispatch({ type: "RETURN_TO", route: route, returnMessage: returnMessage });
        },
        hasMessage: function () { return !!(state.message && state.message.length); },
    }); }, [dispatch, state.message]);
    return (React.createElement(ActionsContext.Provider, { value: actions },
        React.createElement(StateContext.Provider, { value: state }, children)));
};
export var usePlayerErrorMessageActions = function () {
    var context = useContext(ActionsContext);
    if (!context)
        throw new Error("usePlayerErrorMessageActions must be used within Provider");
    return context;
};
export var usePlayerErrorMessageData = function () {
    var context = useContext(StateContext);
    if (!context)
        throw new Error("usePlayerErrorMessageData must be used within Provider");
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./src/context/PlayerErrorMessageContext.tsx
// module id = 71
// module chunks = 1